import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_MARKETING,
  DELETE_MARKETING,
  UPDATE_MARKETING,
  ADD_NEW_MARKETING,
} from "./actionType";

import {
  getMarketingSuccess,
  getMarketingFail,
  deleteMarketingSuccess,
  deleteMarketingFail,
  updateMarketingSuccess,
  updateMarketingFail,
  addMarketingSuccess,
  addMarketingFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveMarketingApi,
  getMarketingApi,
  updateMarketingApi,
  deleteMarketingApi,
  addNewMarketingApi
} from "../../helpers/backend_helper";

function* getMarketing({ payload: marketing }) {
  try {
    const response = yield call(getMarketingApi, marketing);
    yield put(getMarketingSuccess(GET_MARKETING, response.data));
  } catch (error) {
    yield put(getMarketingFail(GET_MARKETING, error));
  }
}

function* onUpdateMarketing({ payload: marketing }) {
  try {
    if (marketing.setApprove) {
      const response = yield call(approveMarketingApi, marketing);
      yield put(updateMarketingSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateMarketingApi, marketing);
      yield put(updateMarketingSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateMarketingFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteMarketing({ payload: marketing }) {
  try {
    const response = yield call(deleteMarketingApi, marketing);
    yield put(deleteMarketingSuccess({ marketing, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteMarketingFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewMarketing({ payload: marketing }) {
  try {
    const response = yield call(addNewMarketingApi, marketing);
    yield put(addMarketingSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addMarketingFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetMarketing() {
  yield takeEvery(GET_MARKETING, getMarketing);
}

export function* watchUpdateMarketing() {
  yield takeEvery(UPDATE_MARKETING, onUpdateMarketing);
}

export function* watchDeleteMarketing() {
  yield takeEvery(DELETE_MARKETING, onDeleteMarketing);
}

export function* watchAddNewMarketing() {
  yield takeEvery(ADD_NEW_MARKETING, onAddNewMarketing);
}

function* marketingSaga() {
  yield all([
    fork(watchGetMarketing),
    fork(watchDeleteMarketing),
    fork(watchUpdateMarketing),
    fork(watchAddNewMarketing)
  ]);
}

export default marketingSaga;
